import Vue from 'vue';
import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';

const state = {
  mineCount: undefined,
  unAssignedCount: undefined,
  allCount: undefined,
  newCount: undefined,
  activeStatusCount: undefined,
  resolvedStatusCount: undefined,
  pendingStatusCount: undefined,
  snoozedStatusCount: undefined,
  allStatusCount: undefined,
  isLoading: false,
};

export const getters = {
  getStats: $state => $state,
  getIsLoading: $state => $state.isLoading,
};

export const actions = {
  get: async ({ commit, rootGetters }, params) => {
    let response = {};
    try {
      if (params.folders) {
        const query = rootGetters['customViews/getCustomViewById'](
          params.folders
        );
        response = await ConversationApi.filter({ queryData: query });
      } else if (params.query) {
        response = await ConversationApi.filter({ queryData: params.query });
      } else {
        response = await ConversationApi.meta(params);
      }
      const {
        data: { meta },
      } = response;
      commit(types.SET_CONV_TAB_META, meta);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CONV_TAB_LOADING, false);
    }
  },
  startLoading({ commit }) {
    commit(types.SET_CONV_TAB_LOADING, true);
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_LOADING]($state, isLoading) {
    Vue.set($state, 'isLoading', isLoading);
  },
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      new_count: newCount,
      active_status_count: activeStatusCount,
      resolved_status_count: resolvedStatusCount,
      pending_status_count: pendingStatusCount,
      snoozed_status_count: snoozedStatusCount,
      all_status_count: allStatusCount,
    } = {}
  ) {
    Vue.set($state, 'mineCount', mineCount);
    Vue.set($state, 'allCount', allCount);
    Vue.set($state, 'unAssignedCount', unAssignedCount);
    Vue.set($state, 'newCount', newCount);
    Vue.set($state, 'activeStatusCount', activeStatusCount);
    Vue.set($state, 'resolvedStatusCount', resolvedStatusCount);
    Vue.set($state, 'pendingStatusCount', pendingStatusCount);
    Vue.set($state, 'snoozedStatusCount', snoozedStatusCount);
    Vue.set($state, 'allStatusCount', allStatusCount);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
